// extracted by mini-css-extract-plugin
module.exports = {"icon":"HeaderNavItem_icon__20Dow"};